import type { ApiClient } from '../client';

// The «Dar de baja» WRITE: anonymize an account, optionally adding it to the Amazon exclusion list
// in the same atomic act. The id rides the path (url-encoded). The body carries the exclusion
// boolean and, on a courier account, the agent's reason — never in the path, since it is free
// text. `reason` travels only when there is one, so a «Usuario» baja still sends a single key and
// nothing personal can reach a request log. The client attaches the Firebase token via the
// Authorization header. Empty 200 — nothing to parse; the caller refetches the account and the
// anonymized ficha IS the effect.
export async function deleteUser(
  client: ApiClient,
  id: string,
  amazonExclusion: boolean,
  reason?: string,
): Promise<void> {
  await client.post(`/app_service/panel/v1/users/${encodeURIComponent(id)}/delete`, {
    amazon_exclusion: amazonExclusion,
    ...(reason === undefined ? {} : { reason }),
  });
}
